import React, { Component } from 'react';
import { css } from 'aphrodite';

import { Flexbox } from './Styles';

import ActionCard from './ActionCard';
import ActionInfo from './ActionInfo';
import CategoryCard from './CategoryCard';
import PrimaryButton from './PrimaryButton';

import Locale from './models/Locale';
import ScrollFix from './ScrollFix';

class ActionMenu extends Component {
  constructor(props) {
    super(props);
    this.state = { actions: null, selectedAction: null };
  }

  render() {
    if (this.state.actions == null) {
      let categories = this.props.scenario.actionCategories(this.props.score.c, this.props.heldActions);
      return(
        <div className={css(Flexbox.row, Flexbox.wrap, Flexbox.axisFill)}>
          {categories.map(category => {
            return <CategoryCard key={category} onSelect={this.handleSelectCategory.bind(this, category)} category={category}/>
          })}
          <CategoryCard onSelect={this.handleSelectAction.bind(this, null)} category={Locale.localized("Do Nothing")}/>
        </div>
      );
    } else if (this.state.selectedAction !== null) {
      return(
        <ActionInfo onSelect={this.handleSelectAction.bind(this, this.state.selectedAction)} onCancel={this.handleCancelAction.bind(this)} action={this.state.selectedAction}/>
      );
    } else {
      return(
        <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossFill, Flexbox.fillVertical)}>
          <div className={css(Flexbox.row, Flexbox.wrap, Flexbox.axisFill, Flexbox.crossCenter)}>
            {this.state.actions.map(action => {
              return <ActionCard key={action.description} onSelect={this.handleShowAction.bind(this, action)} action={action}/>
            })}
          </div>
          <div onClick={this.handleCancelCategory.bind(this)}>
            <PrimaryButton>{Locale.localized("Go Back")}</PrimaryButton>
          </div>
        </div>
      );
    }
  }

  componentDidMount() {
    ScrollFix();
  }

  componentDidUpdate() {
    ScrollFix();
  }

  handleSelectCategory(category) {
    this.setState({actions: this.props.scenario.randomActionsForCategory(category, this.props.score.c, this.props.heldActions, 4)})
  }

  handleCancelCategory() {
    this.setState({ actions: null });
  }

  handleShowAction(action) {
    this.setState({ selectedAction: action });
  }

  handleSelectAction(action) {
    this.props.onSelect(action)
  }

  handleCancelAction() {
    this.setState({ selectedAction: null });
  }
}

export default ActionMenu;



// WEBPACK FOOTER //
// ./src/ActionMenu.js